// Tenant resolver — used PRE-AUTH so the branded sign-in screen knows
// which venture to render. Backed by /api/resolve-tenant which matches
// the request Host (or ?tenant=slug) against tenants.domain.

import { api } from "./client";

export interface ResolveTenantResponse {
  tenant_slug: string;
  source: "query" | "domain";
}

export const resolveTenant = (
  tenantQuery: string | null,
): Promise<ResolveTenantResponse> => {
  const qs = tenantQuery ? `?tenant=${encodeURIComponent(tenantQuery)}` : "";
  return api(`/api/resolve-tenant${qs}`, { redirectOn401: false });
};
